import React from "react";
import { ElementPropsWithElementRefAndRenderer } from "react-scrollbars-custom/dist/types/types";

export default {
  wrapperProps: {
    renderer: ({ elementRef, style, ...restProps }: ElementPropsWithElementRefAndRenderer) => (
      <div {...restProps} ref={elementRef} style={{ ...style, right: 0 }} />
    ),
  },
  contentProps: {
    renderer: ({elementRef, style, ...restProps}: ElementPropsWithElementRefAndRenderer) => (
      <div {...restProps} ref={elementRef} style={{ ...style, height: "100%" }} />
    ),
  },
  noScrollX: true,
  scrollDetectionThreshold: 500,
};
